<template>
  <div class="w120 mc mt20 pt20 pb20 pl20 pr20 bg-w">
    <p class="w100 font-18 tx-c">
      <span class="fl blue font-14 cu-p" @click="backPage">返回详情</span>
      我的评分 - {{ title }}
    </p>
    <p class="w100 tx-c mt10" style="color: #666;">评价说明：每完成在线办理事务一次，就可以对该次服务作一次信用评价。</p>
    <el-table class="w100 mt20" :data="list" stripe border empty-text="暂无可评价记录">
      <el-table-column label="发起人" prop="createUserName" resizable align="center"></el-table-column>
      <el-table-column label="发起时间" resizable align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结办时间" resizable align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="耗时" resizable align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.costTimes | costTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <span class="blue cu-p" v-if="!scope.row.cstate" @click="showJudge(scope.row, false)">评论</span>
          <span class="grey cu-p" v-else @click="fetchJudge(scope.row)">已评</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <el-dialog :visible.sync="isShowJude" :close-on-click-modal="!updataing" :close-on-press-escape="false" :show-close="!updataing" width="1000px">
      <span class="font-16" slot="title">{{ selData.serveName }}</span>
      <div class="w100">
        <div class="w100 flex-box">
          <div class="pr10">服务时长</div>
          <div class="flex-1">
            <el-rate v-model="selData.scoreDuration" :disabled="isJudge" allow-half show-score :score-template="String(selData.scoreDuration * 2)"></el-rate>
          </div>
        </div>
        <div class="w100 pt10 flex-box">
          <div class="pr10">服务质量</div>
          <div class="flex-1">
            <el-rate v-model="selData.scoreQuality" :disabled="isJudge" allow-half show-score :score-template="String(selData.scoreQuality * 2)"></el-rate>
          </div>
        </div>
        <el-input class="w100 mt20" type="textarea" :rows="5" placeholder="请输入内容" v-model="selData.comment" :readonly="isJudge"></el-input>
      </div>
      <span slot="footer" v-if="!isJudge">
        <el-button @click="isShowJude = false" :loading="updataing">取 消</el-button>
        <el-button type="warning" :disabled="this.selData.comment == '' || this.selData.scoreDuration == 0 || this.selData.scoreQuality == 0" :loading="updataing" @click="addJudege">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CollectView",
  components: {},
  props: [],
  data() {
    return {

      loading: false,
      title: "",

      pageNum: 1,
      pageSize: 30,
      total: 0,
      list: [],

      isShowJude: false,
      updataing: false,
      isJudge: false,
      selData: {
        serveId: "",
        serveName: "",
        processInstId: "",
        comment: "",
        scoreDuration: 0,
        scoreQuality: 0
      }
    };
  },
  computed: {},
  mounted() {
    this.title = this.$route.params.title;
    this.initPage();
  },
  methods: {
    fetchList() {
      this.loading = true;
      this.$http
        .post(
          "task/findDoneTaskPage",
          this.$qs.stringify({
            serveId: this.$route.params.id,
            pageNum: this.pageNum,
            pageSize: this.pageSize
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode) {
            this.list = data.RetData.list;
            this.total = data.RetData.total;
          } else {
            this.$notify({
              title: "错误",
              message: data.RetMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络连接错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    },
    initPage() {
      this.pageNum = 1;
      this.list = [];
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    showJudge(obj, isJudge) {
      // console.log(obj);
      this.selData.serveId = obj.processDefId;
      this.selData.serveName = obj.processDefName;
      this.selData.processInstId = obj.processInstId;
      if (isJudge) {
        this.selData.comment = obj.comment;
        this.selData.scoreDuration = obj.scoreDuration;
        this.selData.scoreQuality = obj.scoreQuality;
      } else {
        this.selData.comment = "";
        this.selData.scoreDuration = 5;
        this.selData.scoreQuality = 5;
      }

      this.isJudge = isJudge;
      this.$nextTick(() => {
        this.isShowJude = true;
      });
    },
    fetchJudge(obj) {
      this.loading = true;
      this.$http
        .post(
          "serveComment/getComment",
          this.$qs.stringify({
            processInstId: obj.processInstId
          })
        )
        .then(({ data }) => {
          // console.log(data.RetData);
          if (data.RetStatus == 0 && data.RetCode) {
            const obj = {
              processDefId: data.RetData.processInstId,
              processDefName: data.RetData.processDefName,
              processInstId: data.RetData.processInstId,
              comment: data.RetData.comment,
              scoreDuration: data.RetData.scoreDuration / 2,
              scoreQuality: data.RetData.scoreQuality / 2
            };
            this.showJudge(obj, true);
          } else {
            this.$notify({
              title: "错误",
              message: data.RetMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络连接错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    },
    addJudege() {
      if (
        this.selData.comment == "" ||
        this.selData.scoreDuration == 0 ||
        this.selData.scoreQuality == 0
      ) {
        this.$message({
          message: "内容不能为空且至最低分为1分",
          type: "error"
        });
        return;
      }

      this.updataing = true;
      this.$http
        .post(
          "serveComment/save",
          this.$qs.stringify({
            serveId: this.selData.serveId,
            serveName: this.selData.serveName,
            processInstId: this.selData.processInstId,
            comment: this.selData.comment,
            scoreDuration: this.selData.scoreDuration * 2,
            scoreQuality: this.selData.scoreQuality * 2
          })
        )
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.RetStatus == 0 && data.RetCode) {
            this.$message({
              message: data.RetData,
              type: "success"
            });
            this.fetchList();
          } else {
            this.$message({
              message: data.RetMsg,
              type: "error"
            });
          }
          this.updataing = false;
          this.isShowJude = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.updataing = false;
          this.isShowJude = false;
        });
    },
    backPage() {
      this.$router.push({
        name: "server_info",
        query: {
          id: this.$route.params.id
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
